import { AddressAdd } from '#app/routes/mocra+/_form+/components/addresses/add.tsx'
import { AddressCard } from '#app/routes/mocra+/_form+/components/addresses/card.tsx'
import { type AddressDraft } from '#app/routes/mocra+/_form+/components/addresses/types.ts'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type Props = {
	readonly resources: SectionResources
	readonly address: AddressDraft
	readonly hasAddress: boolean
	readonly errors: readonly string[]
	readonly onSubmit: (draft: AddressDraft) => void
	readonly onEdit: () => void
	readonly onClear: () => void
}

export function HeadquartersSection({
	resources,
	address,
	hasAddress,
	errors,
	onSubmit,
	onEdit,
	onClear,
}: Props) {
	const showErrorList = errors.length > 0 && !hasAddress
	return (
		<Section
			title="Headquarters mailing address"
			description="Capture the physical location regulators use for notices, inspections, and certified mail."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<div className="space-y-4">
				<p className="text-sm font-medium">
					What is the headquarters mailing address?
				</p>
				{hasAddress ? (
					<AddressCard
						title="Headquarters mailing address"
						address={address}
						onEdit={onEdit}
						onRemove={onClear}
						errors={errors.length > 0 ? [...errors] : undefined}
						removeLabel="Clear address"
						removeConfirmTitle="Remove this address?"
						removeConfirmDescription="This section will no longer include a headquarters address until you add a new one."
					/>
				) : (
					<p className="text-muted-foreground text-sm">
						Add the mailing address used for regulator correspondence.
					</p>
				)}
				{hasAddress ? null : (
					<AddressAdd
						onSubmit={onSubmit}
						triggerLabel="Add address"
						className="sm:w-auto"
					/>
				)}
				{showErrorList ? (
					<ul className="text-destructive list-disc space-y-1 pl-5 text-xs">
						{errors.map((error) => (
							<li key={error}>{error}</li>
						))}
					</ul>
				) : null}
			</div>
		</Section>
	)
}
